




















































































import aggregatorModel from '@/components/Company/newCompany/companyInfo/forms/aggregatorModel.vue';
import {
  EnterpriceData as IntefaceEnterpriceData,
  AggregatorModel
} from '@/store/interfaces/company';
import companyTypes from '@/store/types/company';
import liquidations from '@/store/types/liquidations';
import { liquidationKind } from '@/store/interfaces/liquidations';
import Vue, { PropType } from 'vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';

type valueName = {
  name: string;
  value: string;
};

export default Vue.extend({
  name: 'EnterpriceData',
  components: {
    aggregatorModel,
  },
  props: {
    update: {
      required: false,
      default: false,
      type: Boolean,
    },
    enterpriseModel: {
      required: false,
      type: Object as PropType<IntefaceEnterpriceData>,
    },
  },
  data: () => ({
    model: {
      business_name: '',
      artificial_person: false,
      membership_status: 'inactive',
      membership_validation: 'no',
      taxpayer_type: 'non',
      state_code: '',
      business_turn: '',
      liquidation_kind_id: '',
      fixed_withholding: false,
      business_activity_summary: '',
      name: '',
      company_profile_id: '',
      billing_comment: '',
    } as IntefaceEnterpriceData,
    default_type_artificial_person: 1,
    type_artificial_person: '',
    type_artificial_person_array: [
      {
        name: 'Natural',
        value: 'natural',
      },
      {
        name: 'Jurídica',
        value: 'juridica',
      }
    ] as valueName[],
    taxpayer_array: [
      {
        name: 'No contribuyente',
        value: 'non',
      },
      {
        name: 'Pequeño',
        value: 'small',
      },
      {
        name: 'Mediano',
        value: 'medium',
      },
      {
        name: 'Grande',
        value: 'big',
      },
      {
        name: 'Gubernamental',
        value: 'governmental',
      },
      {
        name: 'Otro',
        value: 'other',
      }
    ] as valueName[],
    aggregatorModelData: {
      name: '',
      company_profile_id: '',
      business_activity_summary: '',
      fixed_withholding: false,
    } as AggregatorModel,
  }),
  computed: {
    ...mapGetters({
      getNewCompanyParams: `companyModule/${companyTypes.getters.GET_NEW_COMPANY_PARAMS}`,
      getCompaniesProprofileList: `companyModule/${companyTypes.getters.GET_COMPANIES_PROFILE_LIST}`,
      liquidationKindList: `liquidationModule/${liquidations.getters.GET_LIQUIDATION_KIND_LIST}`,
    }),
    isAggregator(): boolean {
      const isAgg = this.liquidationKindList.data.some(
        (kind: liquidationKind) =>
          kind.id === this.model.liquidation_kind_id &&
          kind.slug === 'agregador'
      );
      return isAgg;
    },
  },
  async mounted(): Promise<void> {
    await this.companiesProfileList();
    this.assignModel();
    this.assignAggregatorModel();
  },
  methods: {
    ...mapActions({
      companiesProfileList: `companyModule/${companyTypes.actions.COMPANIES_PROFILE}`,
    }),
    ...mapMutations({
      setEnterpriceData: `companyModule/${companyTypes.mutations.SET_ENTERPRISE_DATA}`,
    }),
    assignAggregatorModel(): void {
      if (this.update) {
        this.aggregatorModelData = {
          name: this.enterpriseModel.name,
          company_profile_id: this.enterpriseModel.company_profile_id || '',
          fixed_withholding: this.enterpriseModel.fixed_withholding,
          business_activity_summary:
            this.enterpriseModel.business_activity_summary,
        };
      }
    },
    assignModel(): void {
      this.model = this.update
        ? this.enterpriseModel
        : this.getNewCompanyParams.model;
      const artificial = this.model.artificial_person ? 'juridica' : 'natural';
      this.artificialPersonEvaluation(artificial);
    },
    artificialPersonEvaluation(value: string): void {
      if (value === 'juridica') {
        this.model.artificial_person = true;
        this.default_type_artificial_person = 2;
      } else {
        this.model.artificial_person = false;
        this.model.taxpayer_type = 'non';
        this.model.business_turn = '';
      }
    },
    changeValueOfAggregatorModel(val: boolean): void {
      if (val) {
        this.model.name = this.aggregatorModelData.name;
        this.model.company_profile_id =
          this.aggregatorModelData.company_profile_id;
        this.model.fixed_withholding = this.aggregatorModelData.fixed_withholding;
        this.model.business_activity_summary =
          this.aggregatorModelData.business_activity_summary;
      } else {
        this.model.name = '';
        this.model.company_profile_id = '';
        this.model.fixed_withholding = false;
        this.model.business_activity_summary = '';
      }
    },
  },
  watch: {
    model: {
      immediate: true,
      deep: true,
      handler(val: IntefaceEnterpriceData): void {
        setTimeout(() => {
          if (this.update) {
            this.$emit('update:enterpriseModel', val);
          } else {
            this.setEnterpriceData(val);
          }
        }, 500);
      },
    },
    type_artificial_person: {
      immediate: true,
      deep: true,
      handler(val: string): void {
        this.artificialPersonEvaluation(val);
      },
    },
    isAggregator(val: boolean): void {
      this.changeValueOfAggregatorModel(val);
    },
  },
});
